import { render, staticRenderFns } from "./whatsappChat.vue?vue&type=template&id=0f9ab8ca&scoped=true"
import script from "./whatsappChat.vue?vue&type=script&lang=js"
export * from "./whatsappChat.vue?vue&type=script&lang=js"
import style0 from "./whatsappChat.vue?vue&type=style&index=0&id=0f9ab8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ab8ca",
  null
  
)

export default component.exports